import React from 'react';
import PageTemplatePlanoAnual from '../../templates/PageTemplatePlanoAnual';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import StyledGlobal from '../../../../PlanoAnual2025.styled';
import { fetchStorageFile } from 'hooks/StoreFiles';
import { ConfigProvider, Image, Table } from 'antd';
import Colors from 'enums/Colors';
import { ColumnsType } from 'antd/es/table';
import Quote from 'pages/ebooks/components/Quote';
import CardQRcodeVideosPlanoAnual from '../../components/CardQRcodeVideosPlanoAnual';
import styled from 'styled-components';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';

const Styled = {
    CapaFinal: {
        Container: styled.div`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 480px;
            background: #01245e;
            background: linear-gradient(90deg, rgba(1, 36, 94, 1) 0%, rgba(4, 64, 161, 1) 50%, rgba(13, 94, 227, 1) 100%);
        `,
    },
};

interface DataType {
    key: string;
    name: string;
    solucoes: string;
}

const dataSource: DataType[] = [
    {
        key: '1',
        name: 'Gestão Nota 10',
        solucoes: `
        O programa é voltado para o fortalecimento das lideranças educacionais e escolares,
        apoiando a atuação de diretores tecnicamente qualificados e preparados para garantir o
        alcance das metas de aprendizagem e a melhoria dos indicadores educacionais.
        `,
    },
    {
        key: '2',
        name: 'Circuito 360',
        solucoes: `
        O Programa tem como objetivo apoiar as secretarias de educação na
        formulação e gestão de políticas educacionais para os <strong>Anos Iniciais do
        Ensino Fundamental</strong>, com foco na perspectiva de educação integral.
        `,
    },
    {
        key: '3',
        name: 'Se Liga',
        solucoes: `
            O programa é voltado para a alfabetização de estudantes com distorção
            idade-série matriculados do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
    },
    {
        key: '4',
        name: 'Acelera Brasil',
        solucoes: `
            O programa tem como objetivo reduzir a distorção idade-série por meio da
            aceleração do fluxo escolar de estudantes do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
    },
    {
        key: '5',
        name: 'Fórmula da Vitória',
        solucoes: `
        O programa tem como objetivo qualificar a aprendizagem em Língua Portuguesa
        de estudantes dos <strong>Anos Finais do Ensino Fundamental</strong>, contribuindo para
        reverter quadros de reprovação e exclusão no ambiente escolar.
        `,
    },
];

const columns: ColumnsType<DataType> = [
    {
        title: 'SOLUÇÃO EDUCACIONAL ',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
        title: 'DESCRIÇÃO',
        dataIndex: 'solucoes',
        key: 'solucoes',
        align: 'center',
        render: (text: string) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: Colors.White,
                    padding: '20px',
                    borderRadius: 8,
                }}
            >
                <span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        ),
    },
    // {
    //     title: 'CRIANÇAS E JOVENS ATENDIDOS',
    //     dataIndex: 'estudantes',
    //     key: 'estudantes',
    //     align: 'center',
    //     render: (text: string) => (
    //         <div
    //             style={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //                 backgroundColor: Colors.Yellow,
    //                 borderRadius: 8,
    //             }}
    //         >
    //             <span
    //                 style={{
    //                     fontWeight: 'bold',
    //                     color: Colors.White,
    //                     fontSize: '22px',
    //                     alignSelf: 'center',
    //                     justifySelf: 'center',
    //                 }}
    //             >
    //                 {text}
    //             </span>
    //         </div>
    //     ),
    // },
];

interface PageThreeSixPlanoAnualProps {}

const PageThreeSixPlanoAnual: React.FC<PageThreeSixPlanoAnualProps> = () => {
    return (
        <>
            <PageTemplatePlanoAnual numberPage={61} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title blue fontSize="32px">
                    3.6 SÃO LUÍS
                </StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            <strong>São Luís,</strong> capital do Maranhão e um dos principais centros urbanos da Região Nordeste, constitui um
                            município de grande relevância, com uma <strong>população superior a 1 milhão de habitantes.</strong> A economia
                            municipal possui forte base no setor de serviços, destacando-se os setores de administração pública, comércio,
                            serviços, logística e, de maneira proeminente, os complexos portuários.
                        </p>
                        <p>
                            São Luís enfrenta desafios socioeconômicos complexos, marcados por desigualdade social e questões de infraestrutura
                            urbana. Nesse contexto, o investimento em políticas educacionais é crucial para promover a inclusão e o
                            desenvolvimento pleno da cidadania das crianças e jovens do município.
                        </p>
                        <p>
                            Com o objetivo de apoiar a melhoria contínua da qualidade da educação pública e combater as desigualdades
                            educacionais, o município de São Luís iniciou em 2025, uma <strong>parceria</strong> com o{' '}
                            <strong>Instituto Ayrton Senna.</strong> A iniciativa contempla a rede municipal de ensino, buscando implementar
                            soluções que desenvolvam competências educacionais que promovam a melhoria da aprendizagem, a correção de fluxo e
                            fortaleçam a gestão escolar.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <h2>3.6.1 A EDUCAÇÃO NO MUNICÍPIO</h2>
                        <p>
                            Os indicadores educacionais de São Luís em 2024 apontam para um cenário bem próximo ao que é observado na média do
                            país, com exceção dos níveis de aprendizado em Língua Portuguesa que são significativamente inferiores. Na etapa da
                            alfabetização, cujos resultados eram bem abaixo aos observados no Brasil como um todo em 2023, houve um avanço
                            considerável em 2024, se aproximando da média nacional.
                        </p>
                        <StyledGlobal.TitleYellow>ACESSO</StyledGlobal.TitleYellow>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ maxWidth: '600px' }}
                                src={fetchStorageFile('anexo_storage_files_1600116759356058855.png_2025-11-21-1763735601102.png')}
                                alt={`Quadro comparativo dos anos iniciais e finais do Ensino Fundamental, com ícones de escola, professor e matrícula. Nos anos iniciais: 112 escolas, 
                                    1.722 professores e 36.997 matrículas. Nos anos finais: 93 escolas, 1.644 professores e 30.834 matrículas. `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                            <p style={{ fontSize: '14px' }}>Fonte: MEC/Inep - Censo Escolar (2024). Rede Municipal.</p>
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={62} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '480px 1fr',
                        notebook: '400px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>ALFABETIZAÇÃO</StyledGlobal.TitleYellow>
                        <p>
                            São Luís apresentou um <strong>avanço considerável na alfabetização na idade certa em 2024 frente a 2023,</strong>{' '}
                            9,2 pontos percentuais a mais no percentual de estudantes alfabetizados(as), quase o triplo da variação observada na
                            média do país.
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ maxWidth: '600px' }}
                                src={fetchStorageFile('anexo_storage_files_9004597774919567042.png_2025-11-21-1763735793885.png')}
                                alt={`Gráfico de barras verticais apresentando a taxa de alfabetização em São Luís. Em 2023, a barra azul clara indica 47,5%. Em 2024, a barra azul escura indica 58,7%. `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>
                            Fonte: MEC - Indicador Criança Alfabetizada. <br /> MEC/Inep - Censo Escolar.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>DISTORÇÃO IDADE-SÉRIE</StyledGlobal.TitleYellow>
                                <p>
                                    <strong>A distorção idade-série pouco mudou nos últimos dez anos no município,</strong> tanto nos anos
                                    iniciais quanto nos anos finais do Ensino Fundamental, diferente do estado e do Brasil, que apresentaram
                                    quedas significativas no percentual de estudantes atrasados ao longo do ensino fundamental, no mesmo período.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.CardWhite2>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_12623106115642244567.png_2025-11-21-1763736075614.png')}
                                        alt={`Gráfico de barras comparando a distorção idade-série em 2014 e 2024 para anos iniciais e anos finais em São Luís e no Maranhão. 
                                            Anos iniciais: 
                                            — São Luís: 13,9% em 2014 e 11,6% em 2024. 
                                            — Maranhão: 17,8% em 2014 e 7,5% em 2024. 
                                            Anos finais: 
                                            — São Luís: 25,2% em 2014 e 23,7% em 2024. 
                                            — Maranhão: 37,8% em 2014 e 21,6% em 2024. 
                                            As barras de 2014 aparecem em azul escuro; as de 2024 em azul claro, e setas destacam as reduções observadas.” `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.CardWhite2>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Image
                            width={'100%'}
                            height={380}
                            style={{ objectFit: 'cover' }}
                            src={fetchStorageFile('anexo_storage_files_2456626877039892838.webp_2025-11-21-1763736151377.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={63} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '480px 1fr',
                        notebook: '400px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>APROVAÇÃO, REPROVAÇÃO E ABANDONO</StyledGlobal.TitleYellow>
                        <p>
                            As taxas de aprovação são historicamente superiores em São Luís quando comparadas com a média nacional. Isso se deve
                            às relativas baixas taxas de reprovação no município. O abandono, por outro lado, em 2024 foi mais acentuado no
                            município do que na média do país.
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ maxWidth: '600px' }}
                                src={fetchStorageFile('anexo_storage_files_11587853384123157478.png_2025-11-21-1763736366204.png')}
                                alt={`
                                    Gráfico de barras empilhadas mostrando taxas de aprovação, reprovação e abandono em 2024, comparando São Luís, Maranhão e Brasil. Nos anos iniciais, aprovação: São Luís 97,4%, Maranhão 97,5%, Brasil 96,9%. 
                                    Reprovação: São Luís 1,6%, Maranhão 2,1%, Brasil 2,8%. 
                                    Abandono: São Luís 1%, Maranhão 0,4%, Brasil 0,3%. 
                                    Nos anos finais, aprovação: São Luís 93,1%, Maranhão 92,6%, Brasil 92%.  
                                    Reprovação: São Luís 5,2%, Maranhão 5,6%, Brasil 6,6%. 
                                    Abandono: São Luís 1,7%, Maranhão 1,8%, Brasil 1,4%.
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fontes: MEC/Inep - Censo Escolar. MEC/Inep - SAEB. Rede Municipal.</p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>APRENDIZADO ADEQUADO</StyledGlobal.TitleYellow>
                                <p>
                                    Em 2023, os percentuais de estudantes com aprendizado adequado em Língua Portuguesa no 5º ano e no 9º ano do
                                    Ensino Fundamental no município foram de 47,9% e 26%, respectivamente; ambos{' '}
                                    <strong>superiores às médias estaduais, mas inferiores às médias nacionais.</strong>
                                </p>
                                <StyledGlobal.CardWhite2 style={{ width: 'fit-content' }}>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_13338954386734809828.png_2025-11-21-1763736469145.png')}
                                        alt={`
                                            Conjunto de ícones de crianças representando a proporção de aprendizado adequado em Língua Portuguesa no 5º ano e 9º ano do Ensino Fundamental. 
                                            5º ano: São Luís 47,9%, Maranhão 38,8%, Brasil 54,2%. 
                                            9º ano: São Luís 26%, Maranhão 22,1%, Brasil 33,6%. 
                                            Uma parte dos ícones são pintados de azul de acordo com o percentual de cada território, para indicar os estudantes com nível adequado; o restante dos ícones está em cinza. 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.CardWhite2>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_236866295829233953.webp_2025-11-21-1763736696125.webp')}
                                    alt=""
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={64} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '480px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.Title style={{ color: Colors.Blue }}>
                            3.6.2 APRESENTAÇÃO DO
                            <br /> PLANO ANUAL EM SÃO LUÍS
                        </StyledGlobal.Title>
                        <p>
                            A parceria do Instituto Ayrton Senna com o município de São Luís em 2025 foi concretizada pelo Plano Anual Instituto
                            Ayrton Senna, que contemplou a implementação de cinco soluções educacionais para ajudar a rede de ensino a lidar com
                            os desafios de alfabetização, atraso escolar, defasagem de aprendizagens e gestão escolar.
                        </p>

                        <StyledGlobal.CardBlue
                            style={{ maxWidth: '240px', marginTop: '80px', padding: '40px' }}
                            role="img"
                            aria-label="Quadro informativo apresentando o dado: mais de 53 mil professores e alunos da rede pública de ensino"
                        >
                            <div className="metrica">
                                <span> +53 mil </span> <p>professores e alunos da rede pública de ensino</p>
                            </div>
                        </StyledGlobal.CardBlue>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.TableWrapper>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorTextHeading: '#0e60e8',
                                    colorBgBase: '#eae8e6',
                                },
                            }}
                            table={{
                                style: {
                                    background: 'none',
                                },
                            }}
                        >
                            <Table pagination={false} dataSource={dataSource} columns={columns} scroll={{ x: 900 }} style={{ minWidth: 900 }} />
                        </ConfigProvider>
                    </StyledGlobal.TableWrapper>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>
                    Fontes: MEC/Inep - Censo Escolar (2024). Rede Municipal. Sistema de Monitoramento Instituto Ayrton Senna.
                </p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={65} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr 1fr',
                        tablet: '1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <h2>3.6.3 RESULTADOS</h2>
                        <p>
                            Diante dos desafios educacionais de São Luís, a gestão municipal tem apostado estrategicamente na parceria com o
                            Instituto Ayrton Senna, enxergando nos seus programas{' '}
                            <strong>caminhos eficazes para reduzir lacunas de aprendizagem e superar obstáculos estruturais.</strong> Os{' '}
                            <strong>avanços em alfabetização e na proficiência em Língua Portuguesa já são perceptíveis,</strong> favorecendo um
                            futuro mais promissor para os alunos.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Em 2025, no escopo dessa parceria, foram realizados{' '}
                            <strong>
                                16 cursos presenciais com técnicos(as) da secretaria de educação, diretores(as), coordenadores(as)
                                pedagógicos(as) e professores(as),
                            </strong>{' '}
                            a fim de preparálos(as) para implementar os diferentes programas educacionais no município: Gestão Nota 10, Fórmula
                            da Vitória, Circuito 360, Se Liga e Acelera Brasil. Além disso, foram <strong>realizados 9 cursos virtuais,</strong>{' '}
                            para que os(as) educadores(as) tivessem acesso contínuo às formações.
                        </p>
                        <p>
                            Os(as) participantes avaliaram as formações de forma muito positiva, <br />
                            <strong style={{ fontSize: '24px' }}>alcançando um nível de satisfação médio de 90%.</strong>
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Além das formações sobre os programas educacionais, os(as) profissionais de educação contaram com apoio contínuo da
                            equipe do Instituto Ayrton Senna ao longo do ano.
                        </p>
                        <StyledGlobal.CardGray
                            style={{ maxWidth: '250px' }}
                            role="img"
                            aria-label="Foram realizadas 9 oficinas presenciais e 11 oficinas virtuais"
                        >
                            <span> Foram realizadas</span> <strong>9 oficinas presenciais e 11 oficinas virtuais</strong>
                        </StyledGlobal.CardGray>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Quote
                            text={`
                            Um evento baseado em
                            nossa realidade, onde somos
                            ouvidos e direcionados
                            a prática de forma leve
                            e prazerosa. Os novos
                            projetos vêm consolidar
                            nossa prática e nos dar
                            condições de avançar com
                            o ensino aprendizado de
                            nossos alunos.”
                            <br/>
                            <br/>
                            Depoimento de um(a)
                            participante dos cursos
                            presenciais
                            `}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>
                    Fontes: MEC/Inep - Censo Escolar (2024). Rede Municipal. Sistema de Monitoramento Instituto Ayrton Senna.
                </p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={66} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr ',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr ',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    São Luís fortaleceu o acompanhamento de resultados com a{' '}
                                    <strong>institucionalização de um Comitê Gestor,</strong> que estrutura a governança e integra o uso de dados
                                    ao dia a dia, engajando todos os atores na responsabilização e na busca de soluções. O colegiado inclui o
                                    Secretário de Educação, equipes da Secretaria e especialistas do Instituto Ayrton Senna.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Cada programa definiu o que medir e quem deve fazer o acompanhamento, e uma{' '}
                                    <strong>plataforma passou a reunir os dados,</strong> apoiando decisões ágeis focadas no desenvolvimento
                                    integral dos estudantes.
                                </p>
                                <p>
                                    O perfil dos(as) estudantes atendidos(as) variou de acordo com o programa implementado, como mostram os
                                    gráficos ao lado.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Image
                            height={400}
                            style={{ objectFit: 'cover' }}
                            src={fetchStorageFile('anexo_storage_files_2820129592376877021.webp_2025-11-21-1763743738017.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.CardWhite2>
                            <h2 style={{ fontSize: '14px' }}>FAIXA ETÁRIA</h2>
                            <ResponsiveGrid
                                templates={{
                                    desktop: '1fr 1fr',
                                    tablet: '1fr ',
                                }}
                                styles={{ margin: 0, gap: '40px' }}
                            >
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_10115408294309166914.png_2025-11-21-1763743640890.png')}
                                        alt={`
                                            Gráfico de pizza representando distribuição de idades no programa Se Liga: 10 anos (50%), 
                                            11 anos (21,1%), 12 anos (15,5%), 13 anos (9,2%) e 14 anos (4,2%). Cada fatia identifica a porcentagem por faixa etária. 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_10890557993618045478.png_2025-11-21-1763743660347.png')}
                                        alt={`
                                            Gráfico de pizza mostrando a distribuição por idade dos estudantes do Acelera Brasil: 10 anos (9,9%), 
                                            11 anos (48,9%), 12 anos (29%), 13 anos (8,4%) e 14 anos (3,1%), 15 anos ou mais (0,8%). Cada fatia identifica a porcentagem por faixa etária. 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                            </ResponsiveGrid>
                            <p>
                                As turmas do Se Liga no município foram formadas por metade de estudantes com 10 anos, idade esperada para o 5º
                                ano do Ensino Fundamental, e outra metade distribuída entre estudantes entre 11 e 14 anos.
                            </p>
                            <br />
                            <p>
                                Já os(as) estudantes do Acelera Brasil eram relativamente mais velhos(as), com 90% das turmas com estudantes de
                                11 anos ou mais de idade.
                            </p>
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={67} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr ',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr ',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    A participação nos programas já trouxe resultados expressivos do ponto de vista de aprendizado desses(as)
                                    estudantes. Em maio, início do programa,{' '}
                                    <strong>
                                        41% dos(as) alunos(as) das turmas do Se Liga estavam no nível mais baixo de Língua Portuguesa,
                                    </strong>{' '}
                                    com desempenho equivalente ao esperado para a Educação Infantil,{' '}
                                    <strong>percentual que caiu para 17% em setembro.</strong>
                                </p>
                                <p>
                                    Os avanços também foram percebidos nas turmas do Acelera Brasil.{' '}
                                    <strong>
                                        Apenas 11% escreviam palavras com sílabas complexas ortograficamente no início do programa; em setembro,
                                        essa competência havia sido desenvolvida por 46% dos(as) estudantes.
                                    </strong>{' '}
                                    Em relação à produção textual, em maio, apenas 10% escreviam textos com frases ampliadas, com desenvolvimento
                                    lógico de ideias interligadas por conectivo; em setembro esse percentual havia triplicado. Além disso, o
                                    percentual de estudantes com fluência leitora avançou de 40% para 68%, no mesmo período.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.CardWhite2>
                                    <h2 style={{ fontSize: '14px' }}>NÍVEL EM LÍNGUA PORTUGUESA</h2>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_17928684109698899067.png_2025-11-21-1763744046800.png')}
                                        alt={`
                                            Dois grupos de ícones em formato de círculo, com preenchimento em amarelo representando o percentual de estudantes do Se Liga no nível mais baixo em língua portuguesa. 
                                            Texto que acompanha o primeiro grupo diz: ‘Em maio, 41% dos estudantes do Se Liga estavam no nível mais baixo de Língua Portuguesa’ 
                                            Texto que acompanha o segundo grupo diz: ‘Em setembro, o percentual chegou a 17%, ou seja, a maioria evoluiu de nível’ 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_13975140223835470135.png_2025-11-21-1763744068835.png')}
                                        alt={`
                                            Dois grupos de ícones em formato de círculo, com preenchimento em azul representando o percentual de estudantes do Acelera Brasil que escrevem palavras com sílabas complexas.  
                                            Texto que acompanha o primeiro grupo diz: ‘No início do programa, apenas 11% escreviam palavras com sílabas complexas’ 
                                            Texto que acompanha o segundo grupo diz: ‘Em setembro, 46% dos estudantes haviam desenvolvido essa competência’ 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.CardWhite2>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr ',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Os resultados evidenciam que os programas são{' '}
                                    <strong>efetivos para impulsionar a alfabetização e o aprendizado,</strong>
                                    criando condições para que estudantes com maiores desafios avancem com mais segu-rança e autonomia em sua
                                    trajetória, ampliando as chances de{' '}
                                    <strong>concluir a educação básica e exercer plenamente a cidadania.</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    O sucesso dos programas apresentado anteriormente foi potencializado pela{' '}
                                    <strong>distribuição de livros para os(as) estudantes.</strong> Em 2025, foram mais de 10 mil livros
                                    distribuídos, sendo <strong>4.506 livros pedagógicos e 5.890 livros de literatura infanto-juvenil,</strong>{' '}
                                    incluindo exemplares com conteúdo adaptado, garantindo acessibilidade física, visual e cognitiva.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ maxWidth: '600px' }}
                                src={fetchStorageFile('anexo_storage_files_5522722684435637905.png_2025-11-21-1763744162575.png')}
                                alt={`
                                    Quadro com quatro ícones de livros indicando o número de exemplares distribuídos por programa e o número de exemplares de livros de literatura. 
                                    Acelera Brasil: 698 livros; Se Liga: 572 livros; Fórmula da Vitória: 3.236; Livros de Literatura: 5.890 livros 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={68} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr ',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.CardWhite2>
                            <h2 style={{ fontSize: '14px' }}>EXEMPLOS DOS LIVROS DE LITERATURA DISTRIBUÍDOS</h2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_2941439711146107822.png_2025-11-21-1763744461366.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            A prática da leitura, potencializada pelo acesso à um acervo diversificado amplia o{' '}
                            <strong>repertório cultural, contribuindo ainda mais para o desenvolvimento integral dessas crianças.</strong>
                        </p>
                        <p>
                            Como resultado das ações do programa <strong>Fórmula da Vitória,</strong> estudantes que enfrentavam desafios em sua
                            trajetória escolar descobriram na escrita poética uma nova forma de aprender e se expressar. Dessa experiência
                            coletiva surgiu um livro que reúne poemas produzidos nas escolas. Serão <strong>2 mil exemplares impressos</strong> e
                            doados para as escolas do município. A iniciativa evidencia o poder da palavra na recomposição das aprendizagens e
                            reafirma a escola como território de cultura e de desenvolvimento integral.
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_14290210954686123328.png_2025-11-21-1763744746138.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={69} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr ',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr ',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    O programa <strong>Acelera Brasil</strong> inspirou a criação de um curta-metragem que traduz as experiências
                                    dos estudantes em torno da valorização do patrimônio cultural local. Durante o processo, os alunos
                                    descobriram novas formas de olhar para sua cidade, compreender suas tradições e reconhecer-se como parte
                                    dessa história. A obra celebra o aprendizado coletivo e o poder da arte como caminho para fortalecer o
                                    pertencimento, o respeito e o amor pela própria cultura.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    As soluções implementadas pelo Instituto Ayrton Senna foram avaliadas de maneira bem positiva pela equipe
                                    central na Secretaria de Educação, com <strong>80% de satisfação média.</strong> O aspecto mais bem avaliado
                                    foi o <strong>apoio prestado pela equipe do Instituto (84%).</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Image
                            height={420}
                            style={{ width: '100%', objectFit: 'cover' }}
                            src={fetchStorageFile('anexo_storage_files_15751199316218442686.webp_2025-11-21-1763744887479.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr ',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>HISTÓRIAS DE SUPERAÇÃO</StyledGlobal.TitleYellow>
                                <Image
                                    height={420}
                                    style={{ width: '100%', objectFit: 'cover' }}
                                    src={fetchStorageFile('anexo_storage_files_12498514580421254328.png_2025-11-21-1763745078926.png')}
                                    alt=""
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                                <CardQRcodeVideosPlanoAnual />
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Aos 13 anos, após algumas repetências, <strong>Davi</strong> ainda cursava o 5º ano. Com dificuldades para
                                    ler e escrever, ficava atrás dos colegas e até se perdia no trajeto de casa por não compreender placas e
                                    letreiros de ônibus. Encaminhado para a turma do Acelera Brasil, Davi se dedicou intensamente e apresentou
                                    avanços significativos: hoje lê com fluidez, estuda com mais segurança e já finaliza livros inteiros. Sua
                                    maior conquista foi poder ir e voltar sozinho da escola, confiança agora compartilhada por sua mãe. Mais
                                    otimista, ele diz que quer ser médico e estudar para que, no futuro, seus filhos não passem pelo que ele
                                    passou.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual stylesContent={{ padding: 0, gap: 0 }} stylesContainer={{ margin: 0, padding: 0 }}>
                <Styled.CapaFinal.Container>
                    <Image
                        src={fetchStorageFile('anexo_storage_files_17225660729893967470.png_2025-11-21-1763746381553.png')}
                        alt=""
                        preview={{
                            style: {
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            },
                        }}
                    />
                </Styled.CapaFinal.Container>
                <Image
                    width={'100%'}
                    style={{ borderRadius: 0 }}
                    src={fetchStorageFile('anexo_storage_files_9877646194582851674.jpg_2025-11-21-1763746153941.jpg')}
                    alt=""
                    preview={{
                        style: {
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        },
                    }}
                />
            </PageTemplatePlanoAnual>
        </>
    );
};

export default PageThreeSixPlanoAnual;
